<template>
  <div class="mPagination" v-show="max_page > 1">
    <div class="total">共{{ total }}条|</div>
    <div class="select">
      每页显示
      <MSelect :options="pageSizes" v-model="current_size"></MSelect>
      条
    </div>
    <div
      class="before"
      @click="current_page == 1 ? '' : current_page--"
      style="transform: rotate(180deg)"
    >
      <i class="iconfont icon-xiangyou"></i>
    </div>
    <div class="query">
      <template v-if="max_page < 11">
        <div
          class="item"
          v-for="(item, index) in max_page"
          :key="index"
          @click="current_page = item"
          :class="item == current_page ? 'active' : ''"
        >
          {{ item }}
        </div></template
      >
      <template v-else>
        <div class="start">
          <div
            class="item"
            v-for="(item, index) in preLen"
            :key="index"
            @click="current_page = item"
            :class="item == current_page ? 'active' : ''"
          >
            {{ item }}
          </div>
        </div>
        <div class="current">
          <div
            class="item"
            v-for="(item, index) in current_pages"
            :key="index"
            @click="item == '...' ? '' : (current_page = item)"
            :class="item == current_page ? 'active' : ''"
          >
            {{ item }}
          </div>
        </div>
        <div class="last">
          <div
            class="item"
            v-for="(item, index) in preLen"
            :key="index"
            @click="current_page = max_page - preLen + item"
            :class="max_page - preLen + item == current_page ? 'active' : ''"
          >
            {{ max_page - preLen + item }}
          </div>
        </div>
      </template>
    </div>
    <div class="next" @click="current_page == max_page ? '' : current_page++">
      <i class="iconfont icon-xiangyou"></i>
    </div>
  </div>
</template>

<script>
import MSelect from "@/components/common/Select/Select.vue";
export default {
  components: {
    MSelect,
  },
  name: "Pagination",
  props: {
    total: {
      type: Number,
      default: 0,
    },
    currentPage: {
      type: Number,
      default: 0,
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 50],
    },
    currentSize: {
      type: Number,
      default: 10,
    },
  },
  computed: {
    max_page: function () {
      return Math.ceil(this.total / this.current_size);
    },
    current_pages: function () {
      if (
        this.current_page < this.preLen + 4 ||
        this.current_page > this.max_page - this.preLen - 3
      ) {
        return [
          this.preLen + 1,
          this.preLen + 2,
          this.preLen + 3,
          "...",
          this.max_page - 4,
          this.max_page - 3,
          this.max_page - 2,
        ];
      } else {
        return [
          "...",
          this.current_page - 2,
          this.current_page - 1,
          this.current_page,
          this.current_page + 1,
          this.current_page + 2,
          "...",
        ];
      }
    },
  },
  data() {
    return {
      current_page: this.currentPage,
      current_size: this.currentSize,
      preLen: 2,
    };
  },
  watch: {
    current_size: function () {
      this.$emit("sizeChange", this.current_size);
    },
    current_page: function () {
      this.$emit("pageChange", this.current_page);
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.mPagination {
  display: flex;
  align-items: center;
  margin-top: 1rem;
  .total {
    opacity: 0.8;
  }
  .select {
    width: 200px;
    display: flex;
    align-items: center;
  }
  .before {
    background: #fff;
    border-radius: 10px;
    padding: 0.5rem 1rem;
    margin: 0 0.5rem;
    transition: none;
    cursor: pointer;
    &:hover {
      background: #5932ea;
      color: #fff;
    }
  }
  .query,
  .start,
  .current,
  .last {
    display: flex;
    .item {
      background: #fff;
      border-radius: 10px;
      margin: 0 0.2rem;
      padding: 0.5rem 1rem;
      user-select: none;
      cursor: pointer;
      &:hover {
        background: #5932ea;
        color: #fff;
      }
    }
    .active {
      background: #5932ea;
      color: #fff;
    }
  }
  .next {
    background: #fff;
    border-radius: 10px;
    padding: 0.5rem 1rem;
    margin: 0 0.5rem;
    cursor: pointer;
    transition: none;
    &:hover {
      background: #5932ea;
      color: #fff;
    }
  }
}
</style>
